var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnersBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 21",
    filter: "url(#filter0_d_727_357)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.13464,
    y: 1,
    width: 99,
    height: 100,
    rx: 15,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.4847 74.0769C31.4975 74.0769 30.6337 73.7029 29.8933 72.9551C29.153 72.2072 28.7828 71.3347 28.7828 70.3376V49.2104C27.6311 48.2133 26.8701 46.9876 26.4999 45.5334C26.1297 44.0792 26.1709 42.6251 26.6233 41.1709L29.2764 32.7574C29.6054 31.6356 30.1813 30.7631 31.0039 30.1399C31.8266 29.5167 32.7726 29.2051 33.8421 29.2051H67.9614C69.1132 29.2051 70.1209 29.5271 70.9847 30.1711C71.8485 30.8151 72.4449 31.6772 72.7739 32.7574L75.4887 41.1709C75.9412 42.6251 75.972 44.0792 75.5812 45.5334C75.1905 46.9876 74.4192 48.2133 73.2675 49.2104V70.3376C73.2675 71.3347 72.8973 72.2072 72.157 72.9551C71.4166 73.7029 70.5528 74.0769 69.5656 74.0769H32.4847ZM56.6089 47.2784C57.8017 47.2784 58.8095 46.8837 59.6321 46.0943C60.4548 45.3049 60.7838 44.3493 60.6193 43.2275L59.0768 32.9444H52.907V43.2275C52.907 44.3078 53.2566 45.253 53.9558 46.0632C54.6551 46.8733 55.5394 47.2784 56.6089 47.2784ZM45.0712 47.2784C46.2229 47.2784 47.1998 46.8837 48.0019 46.0943C48.804 45.3049 49.205 44.3493 49.205 43.2275V32.9444H43.0352L41.4927 43.2275C41.3282 44.3078 41.6161 45.253 42.3565 46.0632C43.0969 46.8733 44.0018 47.2784 45.0712 47.2784ZM33.8421 47.2784C34.8292 47.2784 35.6827 46.9357 36.4026 46.2501C37.1224 45.5646 37.544 44.7232 37.6674 43.7261L39.2715 32.9444H33.1017L30.2635 42.0434C29.8522 43.3314 30.0167 44.5259 30.7571 45.6269C31.4975 46.7279 32.5258 47.2784 33.8421 47.2784ZM68.2082 47.2784C69.5245 47.2784 70.5631 46.7383 71.324 45.6581C72.085 44.5778 72.2598 43.3729 71.8485 42.0434L69.0103 32.9444H62.8405L64.4446 43.7261C64.568 44.7232 64.9896 45.5646 65.7094 46.2501C66.4293 46.9357 67.2622 47.2784 68.2082 47.2784ZM32.4847 70.3376H69.5656V50.9554C69.6067 50.997 69.4731 51.0178 69.1646 51.0178H68.2082C67.1799 51.0178 66.203 50.7996 65.2776 50.3634C64.3521 49.9271 63.4369 49.252 62.532 48.3379C61.8738 49.1689 61.0512 49.8233 60.064 50.3011C59.0768 50.7789 57.9868 51.0178 56.794 51.0178C55.56 51.0178 54.5008 50.8412 53.6165 50.488C52.7321 50.1349 51.8786 49.5428 51.056 48.7118C50.439 49.4597 49.6575 50.031 48.7114 50.4257C47.7654 50.8204 46.696 51.0178 45.5031 51.0178C44.228 51.0178 43.0969 50.7892 42.1097 50.3322C41.1225 49.8752 40.2793 49.2104 39.58 48.3379C38.5929 49.2104 37.6262 49.8752 36.6802 50.3322C35.7342 50.7892 34.7881 51.0178 33.8421 51.0178H33.0091C32.7418 51.0178 32.567 50.997 32.4847 50.9554V70.3376Z",
    fill: "#044535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_727_357",
    x: 0.134644,
    y: 0,
    width: 103,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_727_357"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_727_357",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersBtn);
export default __webpack_public_path__ + "static/media/PartnersBtn.cfecb89a46a4909941cd3b442fd3fd3e.svg";
export { ForwardRef as ReactComponent };